export default __webpack_public_path__ + "static/media/bri.1c147026.png";